export { default } from './share'